import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import { formatCurrency } from '../../../../utils/currency';
export function getPrice(variations, modifiers, selectedVariation, selectedModifiers, quantity) {
  if (!selectedVariation) {
    return formatCurrency(0);
  }
  var variationPrice = +_get(_find(variations, {
    _id: selectedVariation
  }), 'price', 0) || +_get(_find(variations, {
    name: selectedVariation
  }), 'price', 0);
  var modifierPrices = _map(_filter(modifiers, function (_ref) {
    var modifierId = _ref._id;
    return _includes(selectedModifiers, modifierId);
  }), 'price');
  var modifiersTotal = _reduce(modifierPrices, function (total, nextPrice) {
    return total + +nextPrice;
  }, 0.0);
  var total = variationPrice + modifiersTotal;
  return formatCurrency(total * quantity);
}